<script lang="ts" setup>
import { computed } from 'vue';
import { MAX_NAME_LENGTH } from '@/constants';
import { NotificationThemeInvitationType } from '@/types';
import { formatThemeName, formatUserName } from '@/utils/formatters';
import CardTemplate from './card-template.vue';

// WARN: 通知の表記を変更するときは serviceWorkerHelper.ts の変更漏れがないかも確認する
// WARN: 通知のURLを変更するときは web-push.vue の変更漏れがないかも確認する

interface Props {
  notification: NotificationThemeInvitationType;
  isUnread: boolean;
}

const props = defineProps<Props>();

const url = computed(() =>
  props.notification.theme.is_deleted
    ? undefined
    : `/themes/${props.notification.theme.id}`,
);
const formattedUserName = computed(() =>
  formatUserName(
    props.notification.creator_name,
    props.notification.is_deleted_creator,
    MAX_NAME_LENGTH,
  ),
);
const formattedThemeName = computed(() =>
  formatThemeName(
    props.notification.theme.name,
    props.notification.theme.is_deleted,
  ),
);
</script>
<template>
  <CardTemplate
    :type="notification.type"
    :url="url"
    :is-unread="isUnread"
    :created-at="notification.created_at"
    :user-id="notification.creator_id"
    :image-url="notification.creator_image_url"
  >
    {{ formattedUserName }}さんが、あなたをテーマ「#{{
      formattedThemeName
    }}」に追加しました。
  </CardTemplate>
</template>
